import { z } from 'zod/v3';

import type { CreateShippingAddressRequest } from './schemas';
import { createShippingAddressRequestSchema } from './schemas';

/**
 * 배송지 등록 폼 데이터 스키마
 * @description react-hook-form의 defaultValues로 사용하기 위해 빈 값을 허용하는 폼 전용 스키마
 * @see POST /api/market-place/v2/shipping-address
 */
export const addressRegisterFormDataSchema = z.object({
  /** 상호명 (필수) */
  businessName: z.string(),
  /** 수령자 (필수) */
  recipient: z.string(),
  /** 수령자 전화번호 (필수) */
  recipientPhoneNumber: z.string(),
  /** 우편번호(zonecode, 필수) */
  zipCode: z.string(),
  /** 주소지 (필수) */
  address: z.string(),
  /** 상세주소지 (선택) */
  detailAddress: z.string(),
  /** 법정동 코드(bcode) - 주소 검색 시 설정 */
  regionCode: z.string(),
  /** 특별시/광역시 단위 지역 이름(sido, 필수) */
  provincialLevelDivisionName: z.string(),
  /** 약관 응답 UUID */
  termsId: z.string().optional(),
  /** 약관 동의 상세 UUID 리스트 */
  items: z.array(z.string()).optional(),
  /** 약관 동의 완료 여부 (BottomSheet 분기용 - 서버 전송 X) */
  isAllRequiredAgreementChecked: z.boolean().optional(),
});
export type AddressRegisterFormData = z.infer<
  typeof addressRegisterFormDataSchema
>;

/**
 * AddressRegisterFormData를 API 요청 형식으로 변환
 */
export function toCreateShippingAddressRequest(
  formData: AddressRegisterFormData,
): CreateShippingAddressRequest {
  return createShippingAddressRequestSchema.parse({
    address: formData.address,
    businessName: formData.businessName || undefined,
    detailAddress: formData.detailAddress || undefined,
    provincialLevelDivisionName: formData.provincialLevelDivisionName,
    recipient: formData.recipient,
    recipientPhoneNumber: formData.recipientPhoneNumber,
    regionCode: formData.regionCode || undefined,
    zipCode: formData.zipCode,
    termsId: formData.termsId,
    items: formData.items,
  });
}
